<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>

      <div class="card">
        <div class="controls" v-if="manager && manager.id">
          <img
            @click="handleDelete"
            class="action clickable"
            style="width: 30px; float:right; cursor:pointer"
            src="@/assets/img/delete.svg"
          />
        </div>
        <h3>Manager</h3>
        <div class="inputs" v-if="manager">
          <div class="input">
            <label>
              Name
              <span class="required">*</span>
            </label>
            <input v-model="manager.name" />
          </div>
          <div class="input">
            <label>
              Email
              <span class="required">*</span>
              <span :v-if="!!manager.id" class="required">(Can not be changed)</span>
            </label>
            <input v-model="manager.email" :disabled="!!manager.id" />
          </div>
          <div class="input">
            <label>Password (Optional)</label>
            <input v-model="password" />
          </div>
          <div class="input full select-checkbox">
            <label>
              Departments
              <span class="required">*</span>
            </label>
            <v-select
              v-model="manager.departments"
              :options="departments"
              class="multiple"
              label="name"
              :reduce="(d) => d.id"
              multiple
            ></v-select>
          </div>
          <div class="input full select-checkbox">
            <label>
              Locations
              <span class="required">*</span>
            </label>
            <v-select
              v-model="manager.locations"
              :options="locations"
              class="multiple"
              label="name"
              :reduce="(d) => d.id"
              multiple
            ></v-select>
          </div>
          <div class="input full select-checkbox">
            <label>
              Permissions
              <span class="required">*</span>
            </label>
            <v-select
              v-model="permissions"
              :options="dashboardPages"
              label="display"
              class="multiple"
              :reduce="(d) => d.name"
              multiple
            ></v-select>
          </div>

          <div class="filters">
            <p>Notify Manager When An Employee's Form Failed</p>
            <div class="filter">
              <div class="switch-holder">
                <switches text-enabled="Yes" text-disabled="No" v-model="notifications"></switches>
              </div>
            </div>
          </div>

          <br />
          <div class="btns left">
            <button @click="validate()" class="btn round-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapState } from "vuex";
import DashboardPages from "@/utilities/menu.js";
import Switches from "vue-switches";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  components: {
    Switches
  },
  data() {
    return {
      reduce_function(d, index, arr) {
        return d.name;
      },
      manager: {
        name: "",
        email: "",
        departments: [],
        locations: [],
        permissions: {},
        created_at: Date.now()
      },
      notifications: false,
      password: null
    };
  },
  computed: {
    dashboardPages() {
      return DashboardPages;
    },
    permissions: {
      get() {
        if (this.manager && this.manager.permissions) {
          return Object.keys(this.manager.permissions).filter(
            p => this.manager.permissions[p]
          );
        } else {
          return [];
        }
      },
      set(pages) {
        let permissions = {};
        pages.forEach(p => {
          {
            permissions[p] = true;
          }
        });
        this.manager = Object.assign({}, this.manager, { permissions });
      }
    },
    departments() {
      return Object.values(this.$store.state.departments);
    },
    locations() {
      return Object.values(this.$store.state.locations);
    }
  },
  created() {
    this.$bind(
      "manager",
      db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("managers")
        .doc(this.$route.params.id)
    ).then(manager => {
      if (!manager) {
        this.manager = {
          name: "",
          email: "",
          departments: "",
          locations: "",
          permissions: {},
          created_at: Date.now()
        };
      } else {
        if (this.manager.notifications) {
          this.notifications = this.manager.notifications;
        }
      }
    });
  },
  watch: {
    notifications() {
      this.manager.notifications = this.notifications;
    }
  },

  methods: {
    call(val) {
      debugger;
    },
    validate() {
      let valid = true;
      let manager = this.manager;
      for (let key in manager) {
       if(key !== 'notifications'){
          if (!manager[key]) valid = false;
       }
      }

      if (valid) {
        this.save();
      } else {
        Swal.fire("Please fill in all required fields");
      }
    },
    save() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false
      });
      return Promise.resolve()
        .then(async () => {
          if (this.manager.id) {
            if (this.password) {
              const updateAuthPassword = functions.httpsCallable(
                "updateManagerPassword"
              );
              await updateAuthPassword({
                uid: this.manager.id,
                password: this.password
              });
            }
            return this.$firestoreRefs.manager.set(this.manager, {
              merge: true
            });
          } else {
            const checkLimitAndCreate = functions.httpsCallable(
              "checkLimitAndCreate"
            );
            const addNewManager = functions.httpsCallable("addNewManager");
            console.log(this.$route);
            return addNewManager({
              uid: this.user_doc.id,
              manager_id: this.$route.params.id,
              manager: this.manager,
              password: this.password
            });
          }
        })
        .then(manager => {
          loader.hide();
          return Swal.fire("Manager has been Saved", "", "success");
        })
        .then(() => {
          return this.goTo("/managers");
        })
        .catch(err => {
          loader.hide();
          Swal.fire("Error", err.message, "error");
        });
    },
    handleDelete() {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("managers")
            .doc(this.$route.params.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The page has been deleted.", "success");
              this.goTo("/managers");
            });
        }
      });
    }
  }
};
</script>

<style>
.select-checkbox.input > div {
  position: relative;
}
.select-checkbox.input > div label {
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: -22px;
  color: grey;
  font-weight: normal;
}

.select-checkbox.input > div label input {
  width: auto !important;
  margin: 0 !important;
  margin-right: 5px !important;
}
</style>
